export const sessions = [
  {
    path: '/sessions',
    component: () => import(/* webpackChunkName: "sessions" */ '@/views/sessions/Sessions'),
  },
]
